import { gql } from "@apollo/client"

export const LogOut = gql`
mutation LogOut {
  logOut {
    status
  }
}
`